<template>
  <v-card v-if="item" color="primary" dark class="rounded-custom">
    <v-card-title class="d-flex pt-1 pb-1">
      <v-list-item-avatar>
        <OrganismProfilePicture
          :id="item.organism.id"
          :height="40"
        ></OrganismProfilePicture>
      </v-list-item-avatar>
      <div class="d-flex flex-column">
        <div class="font-weight-medium">
          {{ (item.organism || {}).vernacularName || "--" }}
        </div>
        <div class="caption" style="font-style:italic;">
          {{ (item.organism || {}).scientificName || "--" }}
        </div>
      </div>
      <v-spacer></v-spacer>
      <div>
        <v-btn icon right @click="dialogLibrary = true">
          <SvgIcon icon="cp-zoom-in" fill="white" height="30px"></SvgIcon>
        </v-btn>
      </div>
    </v-card-title>
    <div style="position: relative">
      <OccurrenceGallery
        style="width: 100%"
        :occurrence-id="this.item.id"
        :editable="editable"
        v-on:update:attachementList="updateAttachementList"
      ></OccurrenceGallery>
      <v-divider></v-divider>
    </div>

    <div class="pa-4">
      <div>
        <span class="body-1 font-weight-medium">Abundancia</span>
      </div>
      <span class="font-weight-bold body-2">{{
        item.individualCount || "--"
      }}</span>
      <div class="mt-4">
        <v-chip-group
          v-model="item.individualCount"
          v-if="editable"
          active-class="secondary"
        >
          <v-tooltip
            top
            v-for="(abundanceItem, index) in abundanceList"
            :key="index"
            color="secondary"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-chip
                :outlined="abundanceItem.name !== item.individualCount"
                :value="abundanceItem.name"
                v-on="on"
                v-bind="attrs"
              >
                <SvgIcon
                  :icon="abundanceItem.icon"
                  height="45px"
                  fill="white"
                />
              </v-chip>
            </template>
            <span class="font-weight-bold">{{ abundanceItem.name }}</span>
          </v-tooltip>
        </v-chip-group>
      </div>

      <div
        class="d-flex flex-column flex-sm-row align-center justify-start pt-2"
      >
        <v-checkbox
          class="mb-2 white--text mt-0"
          v-model="item.doubt"
          hide-details
          :disabled="!editable"
        >
          <template v-slot:label>
            <span class="white--text">Tengo dudas del registro</span>
          </template>
        </v-checkbox>
        <v-spacer></v-spacer>
        <v-btn @click="removeItem" rounded v-if="editable" color="accent" dark>
          <v-icon left>mdi-close</v-icon>Quitar
        </v-btn>
      </div>
    </div>

    <v-dialog v-model="dialogLibrary" max-width="600">
      <v-card>
        <v-card-title class="primary--text">
          <span>Ficha especie</span>
          <v-spacer></v-spacer>
          <v-btn @click="dialogLibrary = false" color="primary" icon>
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <div class="pa-4">
          <LibraryItem :id-organism="item.organism.id"></LibraryItem>
        </div>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import OccurrenceGallery from "./OccurrenceGallery";
import OrganismProfilePicture from "../Organism/OrganismProfilePicture";
import LibraryItem from "../Library/LibraryItem";
import SvgIcon from "../SvgIcon";
import api from "../../api.js";

export default {
  components: {
    OccurrenceGallery,
    OrganismProfilePicture,
    SvgIcon,
    LibraryItem
  },
  props: ["item", "editable"],
  data: () => ({
    apiURL: api.baseURL,
    abundanceList: [
      {
        name: "Único (1)",
        icon: "cp-abundance-1"
      },
      {
        name: "Poco abundante (2-10)",
        icon: "cp-abundance-2"
      },
      {
        name: "Abundante (11-50)",
        icon: "cp-abundance-3"
      },
      {
        name: "Muy abundante (50+)",
        icon: "cp-abundance-4"
      }
    ],
    dialogLibrary: false
  }),
  watch: {
    item: {
      // This will let Vue know to look inside the array
      deep: true,

      // We have to move our method to a handler field
      async handler(item, old) {
        this.$emit("update:item", item);
      }
    }
  },
  methods: {
    removeItem() {
      this.$emit("remove", this.item);
    },
    updateAttachementList(attachementList) {
      this.item.attachementList = attachementList;
    }
  }
};
</script>
